import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LeaderboardWidgetComponent from './js/leaderboard-widget.component';

ComponentsFactory.getInstance().define('leaderboard-widget', LeaderboardWidgetComponent);
